// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ai-msm-paper {
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 28px 64px rgba(6, 21, 36, 0.26) !important;
}

.ai-msm {
  position: relative;
  font-family: Lato, sans-serif;
  color: #0b1e2d;
  background: #fff;
  overflow: hidden;
}

.ai-msm-glow {
  position: absolute;
  inset: 0 0 auto 0;
  height: 140px;
  pointer-events: none;
  background:
    radial-gradient(ellipse at 12% 0%, rgba(13, 155, 135, 0.22), transparent 55%),
    radial-gradient(ellipse at 88% 10%, rgba(0, 20, 109, 0.12), transparent 50%);
}

.ai-msm-head {
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 22px 22px 8px;
}

.ai-msm-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 10px;
  padding: 5px 10px;
  border-radius: 999px;
  background: linear-gradient(90deg, #e1f4f0, #eef2f7);
  border: 1px solid #b5dfd7;
  color: #076b5c;
  font-size: 11.5px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.ai-msm-title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: #00146d;
}

.ai-msm-sub {
  margin: 8px 0 0;
  max-width: 52ch;
  font-size: 14px;
  line-height: 1.5;
  color: #5f7484;
}

.ai-msm-analyzing {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 20px 22px 28px;
}

.ai-msm-orb {
  display: grid;
  place-items: center;
  width: 88px;
  height: 88px;
  border-radius: 50%;
  background: radial-gradient(circle at 40% 35%, #fff, #e1f4f0 70%);
  border: 1px solid #b5dfd7;
  box-shadow: 0 12px 28px -16px rgba(7, 107, 92, 0.45);
  animation: ai-msm-pulse 1.8s ease-in-out infinite;
}

.ai-msm-elapsed {
  margin: 0;
  font-size: 13px;
  font-weight: 700;
  color: #076b5c;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.02em;
}

.ai-msm-progress {
  width: 100%;
  max-width: 360px;
}

.ai-msm-progress-label {
  display: block;
  margin-top: 8px;
  text-align: center;
  font-size: 12.5px;
  font-weight: 600;
  color: #8a9ba7;
}

.ai-msm-wait-steps {
  width: 100%;
  max-width: 360px;
  margin: 4px 0 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ai-msm-wait-step {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid #eaf0f0;
  background: #f7fafa;
  font-size: 13.5px;
  font-weight: 600;
  color: #8a9ba7;
  transition: border-color 0.2s, background 0.2s, color 0.2s;
}

.ai-msm-wait-step.is-active {
  border-color: #b5dfd7;
  background: #e1f4f0;
  color: #076b5c;
}

.ai-msm-wait-step.is-done {
  border-color: #dfe7e8;
  background: #fff;
  color: #0b1e2d;
}

.ai-msm-wait-ico {
  display: grid;
  place-items: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  flex: none;
  background: #fff;
  border: 1px solid #dfe7e8;
  color: #076b5c;
}

.ai-msm-wait-step.is-active .ai-msm-wait-ico {
  border-color: #0d9b87;
  background: #fff;
}

.ai-msm-wait-step.is-done .ai-msm-wait-ico {
  border-color: transparent;
  background: #0d9b87;
  color: #fff;
}

.ai-msm-wait-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #0d9b87;
  animation: ai-msm-blink 1.1s ease-in-out infinite;
}

.ai-msm-wait-num {
  font-size: 11px;
  font-weight: 700;
  color: #8a9ba7;
}

.ai-msm-tip {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  max-width: 360px;
  margin-top: 4px;
  padding: 12px 14px;
  border-radius: 10px;
  background: linear-gradient(90deg, #eef2f7, #e1f4f0);
  border: 1px solid #d5e5e2;
  animation: ai-msm-fade-in 0.45s ease;
}

.ai-msm-tip p {
  margin: 0;
  font-size: 13px;
  line-height: 1.45;
  color: #5f7484;
}

.ai-msm-steps {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
}

.ai-msm-steps li {
  padding: 6px 12px;
  border-radius: 999px;
  background: #f7fafa;
  border: 1px solid #dfe7e8;
  font-size: 12.5px;
  font-weight: 600;
  color: #5f7484;
}

.ai-msm-score-panel {
  position: relative;
  margin: 8px 22px 0;
  padding: 18px;
  border-radius: 14px;
  border: 1px solid #c5e4dc;
  background:
    linear-gradient(180deg, rgba(225, 244, 240, 0.65) 0%, #fff 55%);
}

.ai-msm-score-label {
  display: block;
  margin-bottom: 6px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #5f7484;
}

.ai-msm-score-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.ai-msm-score-num {
  font-size: 42px;
  font-weight: 700;
  line-height: 1;
  color: #076b5c;
  font-variant-numeric: tabular-nums;
}

.ai-msm-pill {
  display: inline-flex;
  align-items: center;
  padding: 5px 10px;
  border-radius: 8px;
  background: #00146d;
  color: #fff;
  font-size: 12.5px;
  font-weight: 700;
}

.ai-msm-desc {
  margin: 12px 0 0;
  font-size: 14.5px;
  line-height: 1.5;
  color: #0b1e2d;
}

.ai-msm-stats {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin-top: 16px;
}

.ai-msm-stat {
  padding: 12px 10px;
  border-radius: 10px;
  background: #fff;
  border: 1px solid #eaf0f0;
  text-align: center;
}

.ai-msm-stat strong {
  display: block;
  font-size: 18px;
  font-weight: 700;
  color: #00146d;
  font-variant-numeric: tabular-nums;
}

.ai-msm-stat span {
  display: block;
  margin-top: 4px;
  font-size: 11.5px;
  font-weight: 600;
  color: #8a9ba7;
  letter-spacing: 0.02em;
}

.ai-msm-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 16px;
  margin: 12px 22px 0;
  font-size: 13px;
  color: #5f7484;
}

.ai-msm-meta strong {
  color: #0b1e2d;
  font-weight: 700;
  text-transform: capitalize;
}

.ai-msm-hint {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 14px 22px 0;
  padding: 12px 14px;
  border-radius: 10px;
  background: #f7fafa;
  border: 1px solid #eaf0f0;
}

.ai-msm-hint p {
  margin: 0;
  font-size: 13px;
  line-height: 1.45;
  color: #5f7484;
}

.ai-msm-cap-warn {
  margin: 12px 22px 0;
  padding: 10px 14px;
  border-radius: 10px;
  background: #fff8eb;
  border: 1px solid #f0e0b8;
  color: #7a5a10;
  font-size: 13px;
  line-height: 1.45;
}

.ai-msm-error {
  position: relative;
  padding: 8px 22px 22px;
}

.ai-msm-error p {
  margin: 0 0 16px;
  padding: 14px 16px;
  border-radius: 10px;
  background: #fff5f5;
  border: 1px solid #f0d0d0;
  color: #8a3a3a;
  font-size: 14px;
  line-height: 1.45;
}

.ai-msm-foot {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 10px;
  padding: 18px 22px 22px;
}

@keyframes ai-msm-pulse {
  0%,
  100% {
    transform: scale(1);
    box-shadow: 0 12px 28px -16px rgba(7, 107, 92, 0.45);
  }
  50% {
    transform: scale(1.04);
    box-shadow: 0 16px 32px -14px rgba(7, 107, 92, 0.55);
  }
}

@keyframes ai-msm-blink {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.35;
  }
}

@keyframes ai-msm-fade-in {
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 520px) {
  .ai-msm-stats {
    grid-template-columns: 1fr;
  }

  .ai-msm-score-num {
    font-size: 34px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/containers/AiMaturitySuggestionModal.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,wDAAwD;AAC1D;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,oBAAoB;EACpB;;gFAE8E;AAChF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,oDAAoD;EACpD,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iEAAiE;EACjE,yBAAyB;EACzB,oDAAoD;EACpD,iDAAiD;AACnD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,oDAAoD;EACpD,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB;mEACiE;AACnE;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE;;IAEE,mBAAmB;IACnB,oDAAoD;EACtD;EACA;IACE,sBAAsB;IACtB,oDAAoD;EACtD;AACF;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".ai-msm-paper {\n  border-radius: 16px !important;\n  overflow: hidden;\n  box-shadow: 0 28px 64px rgba(6, 21, 36, 0.26) !important;\n}\n\n.ai-msm {\n  position: relative;\n  font-family: Lato, sans-serif;\n  color: #0b1e2d;\n  background: #fff;\n  overflow: hidden;\n}\n\n.ai-msm-glow {\n  position: absolute;\n  inset: 0 0 auto 0;\n  height: 140px;\n  pointer-events: none;\n  background:\n    radial-gradient(ellipse at 12% 0%, rgba(13, 155, 135, 0.22), transparent 55%),\n    radial-gradient(ellipse at 88% 10%, rgba(0, 20, 109, 0.12), transparent 50%);\n}\n\n.ai-msm-head {\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 22px 22px 8px;\n}\n\n.ai-msm-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 10px;\n  padding: 5px 10px;\n  border-radius: 999px;\n  background: linear-gradient(90deg, #e1f4f0, #eef2f7);\n  border: 1px solid #b5dfd7;\n  color: #076b5c;\n  font-size: 11.5px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.ai-msm-title {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: #00146d;\n}\n\n.ai-msm-sub {\n  margin: 8px 0 0;\n  max-width: 52ch;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #5f7484;\n}\n\n.ai-msm-analyzing {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  padding: 20px 22px 28px;\n}\n\n.ai-msm-orb {\n  display: grid;\n  place-items: center;\n  width: 88px;\n  height: 88px;\n  border-radius: 50%;\n  background: radial-gradient(circle at 40% 35%, #fff, #e1f4f0 70%);\n  border: 1px solid #b5dfd7;\n  box-shadow: 0 12px 28px -16px rgba(7, 107, 92, 0.45);\n  animation: ai-msm-pulse 1.8s ease-in-out infinite;\n}\n\n.ai-msm-elapsed {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 700;\n  color: #076b5c;\n  font-variant-numeric: tabular-nums;\n  letter-spacing: 0.02em;\n}\n\n.ai-msm-progress {\n  width: 100%;\n  max-width: 360px;\n}\n\n.ai-msm-progress-label {\n  display: block;\n  margin-top: 8px;\n  text-align: center;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #8a9ba7;\n}\n\n.ai-msm-wait-steps {\n  width: 100%;\n  max-width: 360px;\n  margin: 4px 0 0;\n  padding: 0;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.ai-msm-wait-step {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  border-radius: 10px;\n  border: 1px solid #eaf0f0;\n  background: #f7fafa;\n  font-size: 13.5px;\n  font-weight: 600;\n  color: #8a9ba7;\n  transition: border-color 0.2s, background 0.2s, color 0.2s;\n}\n\n.ai-msm-wait-step.is-active {\n  border-color: #b5dfd7;\n  background: #e1f4f0;\n  color: #076b5c;\n}\n\n.ai-msm-wait-step.is-done {\n  border-color: #dfe7e8;\n  background: #fff;\n  color: #0b1e2d;\n}\n\n.ai-msm-wait-ico {\n  display: grid;\n  place-items: center;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  flex: none;\n  background: #fff;\n  border: 1px solid #dfe7e8;\n  color: #076b5c;\n}\n\n.ai-msm-wait-step.is-active .ai-msm-wait-ico {\n  border-color: #0d9b87;\n  background: #fff;\n}\n\n.ai-msm-wait-step.is-done .ai-msm-wait-ico {\n  border-color: transparent;\n  background: #0d9b87;\n  color: #fff;\n}\n\n.ai-msm-wait-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #0d9b87;\n  animation: ai-msm-blink 1.1s ease-in-out infinite;\n}\n\n.ai-msm-wait-num {\n  font-size: 11px;\n  font-weight: 700;\n  color: #8a9ba7;\n}\n\n.ai-msm-tip {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  width: 100%;\n  max-width: 360px;\n  margin-top: 4px;\n  padding: 12px 14px;\n  border-radius: 10px;\n  background: linear-gradient(90deg, #eef2f7, #e1f4f0);\n  border: 1px solid #d5e5e2;\n  animation: ai-msm-fade-in 0.45s ease;\n}\n\n.ai-msm-tip p {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.45;\n  color: #5f7484;\n}\n\n.ai-msm-steps {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 8px;\n}\n\n.ai-msm-steps li {\n  padding: 6px 12px;\n  border-radius: 999px;\n  background: #f7fafa;\n  border: 1px solid #dfe7e8;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #5f7484;\n}\n\n.ai-msm-score-panel {\n  position: relative;\n  margin: 8px 22px 0;\n  padding: 18px;\n  border-radius: 14px;\n  border: 1px solid #c5e4dc;\n  background:\n    linear-gradient(180deg, rgba(225, 244, 240, 0.65) 0%, #fff 55%);\n}\n\n.ai-msm-score-label {\n  display: block;\n  margin-bottom: 6px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: #5f7484;\n}\n\n.ai-msm-score-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.ai-msm-score-num {\n  font-size: 42px;\n  font-weight: 700;\n  line-height: 1;\n  color: #076b5c;\n  font-variant-numeric: tabular-nums;\n}\n\n.ai-msm-pill {\n  display: inline-flex;\n  align-items: center;\n  padding: 5px 10px;\n  border-radius: 8px;\n  background: #00146d;\n  color: #fff;\n  font-size: 12.5px;\n  font-weight: 700;\n}\n\n.ai-msm-desc {\n  margin: 12px 0 0;\n  font-size: 14.5px;\n  line-height: 1.5;\n  color: #0b1e2d;\n}\n\n.ai-msm-stats {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 10px;\n  margin-top: 16px;\n}\n\n.ai-msm-stat {\n  padding: 12px 10px;\n  border-radius: 10px;\n  background: #fff;\n  border: 1px solid #eaf0f0;\n  text-align: center;\n}\n\n.ai-msm-stat strong {\n  display: block;\n  font-size: 18px;\n  font-weight: 700;\n  color: #00146d;\n  font-variant-numeric: tabular-nums;\n}\n\n.ai-msm-stat span {\n  display: block;\n  margin-top: 4px;\n  font-size: 11.5px;\n  font-weight: 600;\n  color: #8a9ba7;\n  letter-spacing: 0.02em;\n}\n\n.ai-msm-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px 16px;\n  margin: 12px 22px 0;\n  font-size: 13px;\n  color: #5f7484;\n}\n\n.ai-msm-meta strong {\n  color: #0b1e2d;\n  font-weight: 700;\n  text-transform: capitalize;\n}\n\n.ai-msm-hint {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin: 14px 22px 0;\n  padding: 12px 14px;\n  border-radius: 10px;\n  background: #f7fafa;\n  border: 1px solid #eaf0f0;\n}\n\n.ai-msm-hint p {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.45;\n  color: #5f7484;\n}\n\n.ai-msm-cap-warn {\n  margin: 12px 22px 0;\n  padding: 10px 14px;\n  border-radius: 10px;\n  background: #fff8eb;\n  border: 1px solid #f0e0b8;\n  color: #7a5a10;\n  font-size: 13px;\n  line-height: 1.45;\n}\n\n.ai-msm-error {\n  position: relative;\n  padding: 8px 22px 22px;\n}\n\n.ai-msm-error p {\n  margin: 0 0 16px;\n  padding: 14px 16px;\n  border-radius: 10px;\n  background: #fff5f5;\n  border: 1px solid #f0d0d0;\n  color: #8a3a3a;\n  font-size: 14px;\n  line-height: 1.45;\n}\n\n.ai-msm-foot {\n  display: flex;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 10px;\n  padding: 18px 22px 22px;\n}\n\n@keyframes ai-msm-pulse {\n  0%,\n  100% {\n    transform: scale(1);\n    box-shadow: 0 12px 28px -16px rgba(7, 107, 92, 0.45);\n  }\n  50% {\n    transform: scale(1.04);\n    box-shadow: 0 16px 32px -14px rgba(7, 107, 92, 0.55);\n  }\n}\n\n@keyframes ai-msm-blink {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.35;\n  }\n}\n\n@keyframes ai-msm-fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media (max-width: 520px) {\n  .ai-msm-stats {\n    grid-template-columns: 1fr;\n  }\n\n  .ai-msm-score-num {\n    font-size: 34px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
